import { createAsyncThunk } from 'app/store/utils';
import { getCreateSignedConnectionUrlLink } from 'app/store/Auth/selectors';
import axios from 'axios';
import { CreateSignedConnectionResponse } from 'types/api.types';

export const fetchCreateSignedConnectionUrlEffect = createAsyncThunk(
  'auth/fetchCreateSignedConnectionUrl',
  async (_, { getState }) => {
    const link = getCreateSignedConnectionUrlLink(getState());
    const { data } = await axios.request<CreateSignedConnectionResponse>({
      url: link?.href,
      method: link?.method,
      data: { subscribeToFolderEvents: true },
      withCredentials: true,
    });
    return {
      connectionUrl: data.response._links.connectionUrl.href,
      activityPingInterval: data.response.settings.activityPingInterval,
    };
  }
);
